import PaymentIcon from "@material-ui/icons/Payment";
import PaymentMethodList from "./PaymentMethodList";

export default {
  list: PaymentMethodList,
  icon: PaymentIcon,
};
